import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface Props {
  article: Article;
  layout?: "card" | "row";
  rank?: number;
}

export default function ArticleCard({ article, layout = "card", rank }: Props) {
  if (layout === "row") {
    return (
      <article className="group flex gap-4 border-b border-background-200 py-5 last:border-b-0">
        {rank !== undefined && (
          <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-background-100 font-heading text-sm font-bold text-primary-600">
            {rank}
          </span>
        )}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-secondary-900">
              {article.categoryName}
            </span>
            <span>{article.date}</span>
            <span className="hidden sm:inline">· {article.readTime}</span>
          </div>
          <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
            <Link to={`/article/${article.id}`} className="cursor-pointer transition-colors group-hover:text-primary-700">
              {article.title}
            </Link>
          </h3>
          <p className="mt-1.5 line-clamp-2 hidden text-sm leading-relaxed text-foreground-600 sm:block">
            {article.excerpt}
          </p>
        </div>
        <div className="hidden shrink-0 items-center gap-1 self-center rounded-md bg-background-100 px-2.5 py-1.5 text-xs font-label text-primary-700 md:flex">
          <i className="ri-fire-line" />
          {article.hot}
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-card border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "16 / 10" }}>
        <img
          src={article.cover}
          alt={`${article.title} - ${article.categoryName}话题封面`}
          title={`${article.title} · 黑料在线`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-label text-secondary-900">
          {article.categoryName}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/article/${article.id}`} className="cursor-pointer transition-colors group-hover:text-primary-700">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line" />
            {article.author}
          </span>
          <span className="flex items-center gap-1 rounded-md bg-accent-100 px-2 py-0.5 font-label text-accent-900">
            <i className="ri-fire-line" />
            {article.hot}
          </span>
        </div>
      </div>
    </article>
  );
}